module.exports = __webpack_public_path__ + "static/img/hb_1-min.557730f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_1-min.png
// module id = Un3D
// module chunks = 1